/**
 * Tailwind Stats Donut Slider
 * Handles carousel functionality for the Tailwind stats section
 * Scoped to #product-stats-donuts-slider to avoid conflicts
 */

let tailwindSlideIndex = 1;
let tailwindSliderContainer = null;

// Wait for DOM to be ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTailwindSlider);
} else {
  initTailwindSlider();
}

function initTailwindSlider() {
  tailwindSliderContainer = document.getElementById(
    "product-stats-donuts-slider"
  );
  if (tailwindSliderContainer) {
    const slidesContainer =
      tailwindSliderContainer.querySelector(".donut--slides");
    if (slidesContainer) {
      // Only treat div children as slides (Liquid {% style %} blocks create
      // style tags as siblings, which would otherwise be counted as slides)
      const children = [...slidesContainer.children];
      const slideDivs = children.filter((el) => el.tagName === "DIV");
      slideDivs.forEach((el) => el.classList.add("donut--slide"));
      if (slideDivs[0]) {
        slideDivs[0].classList.add("active-slide");
      }
    }
    tailwindShowSlides(tailwindSlideIndex);
  }
}

function tailwindNextSlide() {
  tailwindShowSlides((tailwindSlideIndex += 1));
}

function tailwindPrevSlide() {
  tailwindShowSlides((tailwindSlideIndex -= 1));
}

function tailwindCurrentSlide(n) {
  tailwindShowSlides((tailwindSlideIndex = n));
}

function tailwindShowSlides(n) {
  if (!tailwindSliderContainer) {
    tailwindSliderContainer = document.getElementById(
      "product-stats-donuts-slider"
    );
    if (!tailwindSliderContainer) {
      console.log("tailwindShowSlides: container not found");
      return;
    }
  }

  // Only count div slides (exclude style tags from Liquid {% style %} blocks)
  const slidesContainer =
    tailwindSliderContainer.querySelector(".donut--slides");
  const children = slidesContainer ? [...slidesContainer.children] : [];
  const slides = children.filter(
    (el) => el.tagName === "DIV" && el.classList.contains("donut--slide")
  );
  const dots =
    tailwindSliderContainer.parentElement?.querySelectorAll(
      ".pagination .dot"
    ) || [];

  console.log("tailwindShowSlides: found", slides.length, "slides, n =", n);

  if (slides.length === 0) return;

  // Wrap slideIndex properly
  if (n > slides.length) {
    tailwindSlideIndex = 1;
  } else if (n < 1) {
    tailwindSlideIndex = slides.length;
  } else {
    tailwindSlideIndex = n;
  }

  // Remove active-slide class from all slides and dots
  slides.forEach((slide) => slide.classList.remove("active-slide"));
  dots.forEach((dot) => dot.classList.remove("active-slide"));

  // Add active-slide class to current slide and dot
  if (slides[tailwindSlideIndex - 1]) {
    slides[tailwindSlideIndex - 1].classList.add("active-slide");
  }
  if (dots[tailwindSlideIndex - 1]) {
    dots[tailwindSlideIndex - 1].classList.add("active-slide");
  }

  // Use translateX to slide the container (like main branch)
  if (slidesContainer) {
    slidesContainer.style.transform = `translateX(${
      -(tailwindSlideIndex - 1) * 100
    }%)`;
  }
}
